import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./context/I18nContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import ThemeApplier from "./components/ThemeApplier";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Actions from "./pages/Actions";
import Results from "./pages/Results";
import Transparency from "./pages/Transparency";
import News from "./pages/News";
import Support from "./pages/Support";
import Donate from "./pages/Donate";
import MonthlyDonor from "./pages/MonthlyDonor";
import AnnualDonor from "./pages/AnnualDonor";
import Volunteer from "./pages/Volunteer";
import Ambassador from "./pages/Ambassador";
import Partners from "./pages/Partners";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import Gallery from "./pages/Gallery";
import Sponsor from "./pages/Sponsor";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import PaypalReturn from "./pages/PaypalReturn";
import MyReceipts from "./pages/MyReceipts";
import WhatsAppButton from "./components/WhatsAppButton";
import AnalyticsTracker from "./components/AnalyticsTracker";
import "./App.css";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (!loading && !user) navigate("/admin/login"); }, [loading, user, navigate]);
  if (loading) return <div className="min-h-screen grid place-items-center bg-ivory text-deep-blue">Chargement…</div>;
  if (!user) return null;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <AnalyticsTracker />
      <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/a-propos" element={<Layout><About /></Layout>} />
      <Route path="/nos-programmes" element={<Layout><Programs /></Layout>} />
      <Route path="/nos-actions" element={<Layout><Actions /></Layout>} />
      <Route path="/nos-resultats" element={<Layout><Results /></Layout>} />
      <Route path="/transparence" element={<Layout><Transparency /></Layout>} />
      <Route path="/actualites" element={<Layout><News /></Layout>} />
      <Route path="/soutenir" element={<Layout><Support /></Layout>} />
      <Route path="/faire-un-don" element={<Layout><Donate /></Layout>} />
      <Route path="/donateur-mensuel" element={<Layout><MonthlyDonor /></Layout>} />
      <Route path="/donateur-annuel" element={<Layout><AnnualDonor /></Layout>} />
      <Route path="/devenir-benevole" element={<Layout><Volunteer /></Layout>} />
      <Route path="/devenir-ambassadeur" element={<Layout><Ambassador /></Layout>} />
      <Route path="/entreprises-partenaires" element={<Layout><Partners /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/merci" element={<Layout><ThankYou /></Layout>} />
      <Route path="/galerie" element={<Gallery />} />
      <Route path="/parrainage" element={<Sponsor />} />
      <Route path="/paiement/succes" element={<PaymentSuccess />} />
      <Route path="/paiement/annule" element={<PaymentCancel />} />
      <Route path="/paiement/paypal" element={<PaypalReturn />} />
      <Route path="/mes-recus" element={<MyReceipts />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <ThemeApplier />
          <WhatsAppButton />
          <Toaster position="top-right" richColors />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
